import { useMutation } from "@tanstack/react-query"
import { secretStorage } from "config"
import { useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import { actions } from "store"
import { updateDefaultUserRolesFetch } from "store/middlewares/user.crud"

const useRemoveDefaultRole = () => {
    const dispatch = useDispatch()
    const { user, defaultRole } = useSelector(state => state.user)

    const { mutateAsync: updateDefaultUserRoles } = useMutation({
        mutationFn: (val) => {
            dispatch(actions.setUpdateRoleIsPending(true))
            updateDefaultUserRolesFetch(val)
        },
        onSettled: () => {
            dispatch(actions.setUpdateRoleIsPending(false))
        }
    })

    const removeDefaultRole = useCallback(async () => {
        await updateDefaultUserRoles(null)
        let nUser = { ...user, default_user_roles: null }
        secretStorage.setUser(nUser)
        dispatch(actions.setUser(nUser))
    }, [defaultRole, user])

    return removeDefaultRole
}

export default useRemoveDefaultRole